import { render, staticRenderFns } from "./TheContent.vue?vue&type=template&id=48e4eb7c"
import script from "./TheContent.vue?vue&type=script&lang=ts"
export * from "./TheContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports